<template>
    <v-sheet class="" width="100%">
        <v-row class="mt-5 pa-0" no-gutters></v-row>
        <CmmYYMM @sltHypDt="getCompDt"></CmmYYMM>
        <v-divider class="mt-4 mx-2"></v-divider>
        <v-row class="greyE01 mx-2" no-gutters>
            <v-col class="txtAlgnMid tableBR" style="padding-top: 28px;" cols="2">
                <span class="font-weight-medium">일자</span>
            </v-col>
            <v-col class="" cols="10">
                <v-row class="pa-0" no-gutters>
                    <v-col class="txtAlgnMid py-1" cols="12">
                        <span class="font-weight-medium">야간보호</span>
                    </v-col>
                </v-row>
                <v-divider class=""></v-divider>
                <v-row class="pa-0" no-gutters>
                    <v-col class="txtAlgnMid tableBR py-1" style="line-height: 1.2;" cols="4">
                        <span class="font-weight-medium">야간점검<br>일지</span>
                    </v-col>
                    <v-col class="txtAlgnMid tableBR py-1" style="line-height: 1.2;" cols="4">
                        <span class="font-weight-medium">주간→야간<br>인계사항</span>
                    </v-col>
                    <v-col class="txtAlgnMid py-1" style="line-height: 1.2;" cols="4">
                        <span class="font-weight-medium">야간→주간<br>인계사항</span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-divider class="mx-2"></v-divider>
        <div
            v-if="inspRecList.length > 0"
            class="d-inline-block overflow-y-auto"
            :style="{ 'width': '100%', 'height': ($vuetify.breakpoint.height - 210) + 'px' }">
            <v-row
                class="pa-0 mx-2 tableBB"
                v-for="(lst, i) in inspRecList" :key="i"
                no-gutters>
                <v-col class="txtAlgnMid px-2 py-1 tableBR" cols="2">
                    <span v-if="lst.day == 0" class="fontDotEight red--text">{{ lst.dday }}일</span>
                    <span v-else-if="lst.day == 6" class="fontDotEight blue--text">{{ lst.dday }}일</span>
                    <span v-else class="fontDotEight">{{ lst.dday }}일</span>
                </v-col>
                <v-col class="" cols="10">
                    <v-row class="pa-0" no-gutters>
                        <v-col
                            :class="['txtAlgnMid tableBR sltFld py-1', lst.inspCnt == 0 ? 'nmlBfClr-yellow001' : 'nmlBfClr-green001']"
                            @click="onInspAreaMdl(lst.inspDt)"
                            cols="4">
                            <span v-if="lst.inspCnt == 0" class="fontDotEight">미작성</span>
                            <span v-else class="fontDotEight">{{ lst.inspCnt }}건</span>
                        </v-col>
                        <v-col
                            :class="['txtAlgnMid tableBR sltFld py-1', lst.tkeCnt1 == 0 ? 'nmlBfClr-yellow001' : 'nmlBfClr-green001']"
                            @click="onHndOvrMdl(lst.inspDt, 1)"
                            cols="4">
                            <span v-if="lst.tkeCnt1 == 0" class="fontDotEight">미작성</span>
                            <span v-else class="fontDotEight">{{ lst.tkeCnt1 }}건</span>
                        </v-col>
                        <v-col
                            :class="['txtAlgnMid sltFld py-1', lst.tkeCnt2 == 0 ? 'nmlBfClr-yellow001' : 'nmlBfClr-green001']"
                            @click="onHndOvrMdl(lst.inspDt, 2)"
                            cols="4">
                            <span v-if="lst.tkeCnt2 == 0" class="fontDotEight">미작성</span>
                            <span v-else class="fontDotEight">{{ lst.tkeCnt2 }}건</span>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <v-row v-else class="pa-0 mx-2 tableBB" no-gutters>
            <v-col class="txtAlgnMid pa-2" cols="12">
                <span class="fontDotEight">※ 조회된 목록이 없습니다.</span>
            </v-col>
        </v-row>

        <!-- 팝업 영역 -->
        <v-dialog
            v-model="lclMdlInf.isOn"
            content-class="round"
            persistent>
            <NtyInspAreaMdl
                v-if="lclMdlInf.typ == '01'"
                :sltYMD="mdlInf.dt"
                @offMdl="offInspAreaMdl">
            </NtyInspAreaMdl>
            <NtyInspDtlMdl
                v-else-if="lclMdlInf.typ == '02'"
                :sltYMD="mdlInf.dt"
                :sltPk="mdlInf.pk"
                :sltOrd="mdlInf.ord"
                @offMdl="offInspDtlMdl">
            </NtyInspDtlMdl>
            <HndOvrMdl
                v-else-if="lclMdlInf.typ == '03'"
                :sltYMD="mdlInf.dt"
                :sltClcd="mdlInf.clcd"
                @offMdl="offHndOvrMdl">
            </HndOvrMdl>
            <HndOvrSavMdl
                v-else-if="lclMdlInf.typ == '04'"
                :sltYMD="mdlInf.dt"
                :sltPk="mdlInf.pk"
                :sltClcd="mdlInf.clcd"
                @offMdl="offHndOvrSavMdl">
            </HndOvrSavMdl>
        </v-dialog>
    </v-sheet>
</template>

<script>
import { http } from '@/assets/js/baseAxios';

import NtyInspAreaMdl from './sfty/NtyInspAreaMdl.vue'
import NtyInspDtlMdl from './sfty/NtyInspDtlMdl.vue'
import HndOvrMdl from './sfty/HndOvrMdl.vue'
import HndOvrSavMdl from './sfty/HndOvrSavMdl.vue'

import CmmYYMM from '../cmm/CmmYYMM_kr.vue';

export default {
    name: 'NtyInspJrnls',

    components: {
        CmmYYMM,
        NtyInspAreaMdl,
        NtyInspDtlMdl,
        HndOvrMdl,
        HndOvrSavMdl,
    },

    props: {

    },

    created: function(){
        this.nowDt = this.$store.getters.getPrsntDt('yyyymmdd')
    },

    mounted: function(){
        this.$nextTick(function () {
            this.$parent.$parent.appBarTtl = '야간점검(인계) 일지'

            if(this.sltDt == '')
                this.getCompDt(this.$moment().format('YYYY-MM'))
        })
    },

    computed: {

    },

    watch:{

    },
        
    methods: {
        // 야간점검(인계) 일지 월별 조회
        getNtyInsp: function (){
            this.inspRecList.splice(0)

            let obj = {}
            obj.inqYmdStart = this.$moment(this.sltDt, 'YYYY-MM-DD').format('YYYYMMDD')
            obj.inqYmdEnd = this.$moment(this.sltDt, 'YYYY-MM-DD').endOf('month').format('YYYYMMDD')
           
            http.post('empApp/selNgtInspDtlSmryList', obj)
                .then((response) => ( this.ntyInspRst(response.data) ))
                .catch((error) => console.log('axios error /empApp/selNgtInspDtlSmryList : ' + error))
        },

        ntyInspRst: function (res) {
            if(res.statusCode == 200){
                res.data.forEach(itm => {
                    itm.dday = this.$moment(itm.inspDt, 'YYYYMMDD').format('DD')
                    itm.day = this.$moment(itm.inspDt, 'YYYYMMDD').day()
                });

                this.inspRecList = res.data
            }
        },

        getCompDt: function (dt) {
            this.sltDt = this.$moment(dt, 'YYYY-MM').format('YYYY-MM-DD')
            // 2025년 이전 날짜 선택 시 조회 불가
            if(this.$moment(this.sltDt, 'YYYY-MM-DD').isBefore('2025-01-01')){
                this.inspRecList.splice(0)
                return
            }

            if(this.$store.getters.getToken != ''){
                // 점검일지 조회 API 호출
                this.getNtyInsp()
            }
        },

        onInspAreaMdl: function (dt) {
            this.mdlInf.dt = dt
            this.onLclMdl('01')
        },

        offInspAreaMdl: function () {
            this.mdlInf.dt = ''
            if(this.$store.getters.getToken != ''){
                // 점검일지 조회 API 호출
                this.getNtyInsp()
            }

            this.rstLclMdlInf()
        },

        onInspDtlMdl: function (pk, ord) {
            this.mdlInf.pk = pk
            if(ord != null)
                this.mdlInf.ord = ord

            this.onLclMdl('02')
        },

        offInspDtlMdl: function () {
            this.mdlInf.pk = 0
            this.mdlInf.ord = 0
            this.onInspAreaMdl(this.mdlInf.dt)
        },

        onHndOvrMdl: function (dt, typ) {
            this.mdlInf.dt = dt
            this.mdlInf.clcd = typ

            this.onLclMdl('03')
        },

        offHndOvrMdl: function () {
            this.mdlInf.dt = ''
            this.mdlInf.clcd = 0

            if(this.$store.getters.getToken != ''){
                // 점검일지 조회 API 호출
                this.getNtyInsp()
            }
            this.rstLclMdlInf()
        },

        onHndOvrSavMdl: function (pk) {
            this.mdlInf.pk = pk

            this.onLclMdl('04')
        },

        offHndOvrSavMdl: function () {
            this.onHndOvrMdl(this.mdlInf.dt, this.mdlInf.clcd)
        },

        // 통합 팝업 오픈
        onLclMdl: function (txt) {
            this.lclMdlInf.typ = txt
            this.lclMdlInf.isOn = true
        },

        // 통합 팝업 초기화
        rstLclMdlInf: function () {
            this.lclMdlInf.typ = ''
            this.lclMdlInf.isOn = false
        },
    },

    data: () => ({
        sltDt: '',
        nowDt: '',
        inspRecList: [],
        mdlInf: { dt: '', pk: 0, ord: 0, clcd: 1 },
        lclMdlInf: { isOn: false, maxWidth: 800, typ: '' },
    }),
};
</script>